import { render, staticRenderFns } from "./CampaignPropertyDisplay.vue?vue&type=template&id=7897e1a6&scoped=true"
import script from "./CampaignPropertyDisplay.vue?vue&type=script&lang=js"
export * from "./CampaignPropertyDisplay.vue?vue&type=script&lang=js"
import style0 from "./CampaignPropertyDisplay.vue?vue&type=style&index=0&id=7897e1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7897e1a6",
  null
  
)

export default component.exports